import { render, staticRenderFns } from "./lainnya.vue?vue&type=template&id=20d19d88&"
import script from "./lainnya.vue?vue&type=script&lang=js&"
export * from "./lainnya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnGroup,QBtn,QInput,QIcon,QMarkupTable,QPagination,QDialog,QCard,QCardSection,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnGroup,QBtn,QInput,QIcon,QMarkupTable,QPagination,QDialog,QCard,QCardSection,QCardActions})
